import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { IUser } from '../interfaces/user.interface';
import { UserValidationService } from './user-validation.service';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class UserValidationResolver implements Resolve<boolean> {
  constructor(
    private readonly userService: UserService,
    private readonly userValidationService: UserValidationService
  ) {}

  resolve(): Observable<boolean> {
    return this.userService.getUser().pipe(
      map((user: IUser) => {
        this.userValidationService.validateUser(user);
        return true;
      }),
      catchError(() => of(true))
    );
  }
}
